<template>
  <main :id="$style.main">
    <div :id="$style.title">
      <figure>
        <div :class="$style.title_img"></div>
        <figcaption>〜 ルック ミー 〜</figcaption>
      </figure>
      <div :id="$style.caption">
        ご来館のお客様から松井選手やミュージアムにまつわる話題などをメッセージボードに書いて頂き
        <br />そのボードを持ったご本人様の写真を楽しんで頂く企画です。
      </div>
    </div>
    <section>
      <div :class="$style.selector">
        <multiselect
          v-model="latest_num"
          :class="$style.select"
          :options="id_num"
          :selectLabel="''"
          :deselectLabel="''"
          :searchable="false"
          @select="handleClick"
        ></multiselect>
      </div>

      <div :class="$style.gallery">
        <vue-gallery :images="items_data" :options="options" :index="index" @close="index = null"></vue-gallery>
        <div
          :class="$style.image"
          v-for="(item, itemIndex) in items_data"
          :key="itemIndex"
          @click="index=itemIndex"
          :style="{ backgroundImage: 'url(' + item.image + ')' }"
        ></div>
      </div>
    </section>
    <header-return></header-return>
  </main>
</template>

<script lang="ts">
import Vue from "vue";
import { LookMe } from "@/api";
import VueGallery from "vue-gallery";
import Multiselect from "vue-multiselect";
import HeaderReturn from "@/components/organsms/HeaderReturn.vue";

export default Vue.extend({
  name: "LookMeView",

  components: {
    VueGallery,
    Multiselect,
    HeaderReturn,
  },
  data() {
    return {
      items_data: [],
      latest_num: 0,
      index: null,
      options: {
        urlProperty: "image"
      },
      id_num: []
    };
  },
  mounted() {
    this.getLatestItem();
  },

  methods: {
    handleClick(id_number_mim) {
      // LookMe.getLookmeItem(id_number_mim).then(({ count, results }) => {
      LookMe.getLookmeItem(id_number_mim).then(({ results }) => {
        this.items_data = results;
      });
    },
    getLatestItem() {
      LookMe.getLookmeCount().then(({ latest_num }) => {
        this.latest_num = Math.floor(latest_num / 100) * 100;

        // selectorのためのlistを作成
        const jsranger = require("jsranger");
        // this.id_num = jsranger(0, 2100, 100);
        this.id_num = jsranger(0, this.latest_num + 100, 100);
        this.id_num = this.id_num.reverse();

        // LookMe.getLookmeItem(this.latest_num).then(({ count, results }) => {
        LookMe.getLookmeItem(this.latest_num).then(({ results }) => {
          this.items_data = results;
        });
      });
    }
  }
});
</script>

<style lang="scss">
// SP PreviewのためのCSS
@media only screen and (max-width: 1023px) {
  .slide-content {
    margin-top: 50px !important;
    object-fit: cover;
    height: 74vh !important;
    width: 100% !important;
  }
  .description {
    // background-color: rgba(51, 51, 51, 0.7);
    border-radius: 5px;
    padding: 0 5px;
    // padding-top: 10px;
    // top: auto !important;
    // bottom: 0px;
    top: 84vh !important;
    left: 0;
    text-align: center;
    width: 100%;
    height: 11vh;
    // width: 300px;
    width: 90%;
    font-size: 13px;
    line-height: 15px;
    overflow: scroll;
  }
  .prev,
  .next,
  .close {
    color: #fff !important;
  }
}
// PC PreviewのためのCSS
@media only screen and (min-width: 1024px) {
  .description {
    top: auto !important;
    bottom: 0;
    left: 0;
    text-align: center;
    width: 100%;
    height: 80px;
    padding: 0 220px;
  }
  .prev,
  .next,
  .close {
    color: #fff !important;
  }
}
</style>

<style lang="scss" module>
@import "../../assets/style/base.scss";

@media only screen and (max-width: 1023px) {
  #main {
    background-color: #dff4e7;
    display: flex;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
    #title {
      figure {
        display: flex;
        align-items: center;
        flex-direction: column;
        flex-wrap: wrap;
        .title_img {
          background-image: url("../../assets/img/lookme.png");
          background-repeat: no-repeat;
          margin: 0;
          height: 70px;
          width: 275px;
          border-style: none;
        }
        figcaption {
          text-align: center;
        }
      }
      #caption {
        text-align: center;
        font-size: 14px;
        margin: 0px 35px;
      }
    }
    section {
      margin: 60px 0px;
      .selector {
        width: 100%;
        margin-bottom: 20px;
        .select {
          width: 200px;
          margin: auto;
        }
      }
      .gallery {
        // width: 90%;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin: auto;
      }
      .image {
        float: left;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        border: 1px solid #ebebeb;
        margin: 5px;
        width: 150px;
        height: 190px;
      }
    }
  }
}
@media only screen and (min-width: 1024px) {
  #main {
    background-color: #dff4e7;
    display: flex;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
    #title {
      figure {
        display: flex;
        align-items: center;
        flex-direction: column;
        flex-wrap: wrap;
        .title_img {
          background-image: url("../../assets/img/lookme.png");
          background-repeat: no-repeat;
          margin: 0;
          height: 70px;
          width: 275px;
          border-style: none;
        }
        figcaption {
          text-align: center;
        }
      }
      #caption {
        text-align: center;
      }
    }
    section {
      margin: 90px 0px;
      .selector {
        width: 100%;
        margin-bottom: 20px;
        .select {
          width: 200px;
          margin: auto;
        }
      }
      .gallery {
        width: 90%;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin: auto;
      }
      .image {
        float: left;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        border: 1px solid #ebebeb;
        margin: 5px;
        width: 235px;
        height: 305px;
      }
    }
  }
}
</style>
